import React, { useContext } from 'react';
import cn from 'classnames';
import { Button } from '../../button/esm';
import { Spinner } from '../../spinner/esm';
import { Text } from '../../typography/esm';
import { ConfirmationContext } from './context.js';
import { formatMsAsMinutes } from './utils.js';

var styles = {"component":"confirmation__component_o4w4f","phone":"confirmation__phone_o4w4f","typographyTheme":"confirmation__typographyTheme_o4w4f","typographyThemeMobile":"confirmation__typographyThemeMobile_o4w4f","compact":"confirmation__compact_o4w4f","loaderWrap":"confirmation__loaderWrap_o4w4f","left":"confirmation__left_o4w4f","center":"confirmation__center_o4w4f","codeInput":"confirmation__codeInput_o4w4f","smsBtn":"confirmation__smsBtn_o4w4f","smsComeLink":"confirmation__smsComeLink_o4w4f","countdownContainer":"confirmation__countdownContainer_o4w4f","countdownMobile":"confirmation__countdownMobile_o4w4f","countdownLoaderMobile":"confirmation__countdownLoaderMobile_o4w4f","getCodeButton":"confirmation__getCodeButton_o4w4f","getCodeButtonMobile":"confirmation__getCodeButtonMobile_o4w4f","containerInput":"confirmation__containerInput_o4w4f"};
require('./components/screens/initial/index.css');

var CountdownSection = function (_a) {
    var _b, _c;
    var codeSendHintVisible = _a.codeSendHintVisible, timePassed = _a.timePassed, processing = _a.processing, mobile = _a.mobile, handleSmsRetryClick = _a.handleSmsRetryClick;
    var _d = useContext(ConfirmationContext), state = _d.state, texts = _d.texts, timeLeft = _d.timeLeft, blockSmsRetry = _d.blockSmsRetry, breakpoint = _d.breakpoint, client = _d.client;
    var renderText = function (text) {
        var _a;
        return (React.createElement(Text, { className: cn(styles.countdownContainer, (_a = {},
                _a[styles.countdownMobile] = mobile,
                _a[styles.typographyTheme] = !mobile,
                _a)), view: mobile ? 'primary-small' : 'primary-medium', tag: 'div' }, text));
    };
    if (codeSendHintVisible)
        return renderText(texts.codeSended);
    if (processing) {
        return (React.createElement("div", { className: cn(styles.loaderWrap, styles.countdownContainer, (_b = {},
                _b[styles.countdownLoaderMobile] = mobile,
                _b[styles.typographyTheme] = !mobile,
                _b)) },
            React.createElement(Spinner, { preset: 24, visible: true }),
            React.createElement("span", { className: styles.loaderText }, state === 'CODE_CHECKING' ? texts.codeChecking : texts.codeSending)));
    }
    if (blockSmsRetry)
        return renderText(texts.noAttemptsLeft);
    if (timePassed) {
        return (React.createElement(Button, { size: mobile ? 'xs' : 'xxs', view: 'secondary', onClick: handleSmsRetryClick, className: cn(styles.getCodeButton, (_c = {}, _c[styles.getCodeButtonMobile] = mobile, _c)), breakpoint: breakpoint, client: client }, texts.buttonRetry));
    }
    return renderText("".concat(texts.countdown, " ").concat(formatMsAsMinutes(timeLeft)));
};

export { CountdownSection as C, styles as s };
